import { ThemeOptions } from '@mui/material';

/**
 * View Tooltip props and classes at https://mui.com/material-ui/api/tooltip/#css
 */
export const tooltip: ThemeOptions['components'] = {
  MuiTooltip: {
    defaultProps: {
      placement: 'top',
    },
    styleOverrides: {
      tooltip: ({ theme }) => ({
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.borderState.default}`,
        color: theme.palette.text.secondary,
      }),
      arrow: ({ theme }) => ({
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.borderState.default}`,
      }),
    },
  },
};
